import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Checkbox, FormControlLabel } from '@material-ui/core';

class FHECheckbox extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        checked: PropTypes.bool.isRequired,
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        color: PropTypes.string,
        labelPlacement: PropTypes.string,
        onChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        disabled: false,
        color: 'primary',
        labelPlacement: 'end'
    };

    render() {
        const { checked, label, value, disabled, color, labelPlacement, onChange, classes } = this.props;
        return (
            <div className={classes.FHECheckboxContent}>
                <FormControlLabel
                    disabled={disabled}
                    label={label}
                    labelPlacement={labelPlacement}
                    control={<Checkbox checked={checked} onChange={onChange} name={value} color={color} />}
                />
            </div>
        );
    }
}

const styles = theme => ({
    FHECheckboxContent: {
        display: 'flex',
        alignItems: 'center',
        height: '100%'
    }
});

export default withStyles(styles, { withTheme: true })(FHECheckbox);



// WEBPACK FOOTER //
// ./data/components/FHECheckBox.js